import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import OrderTemplateOverview from 'orders/presentation/components/molecules/OrderTemplateOverview/OrderTemplateOverview'
import ContainerlessRuleTable from 'orders/presentation/components/molecules/ContainerlessRuleTable/ContainerlessRuleTable'

interface Props {
    progress: OrderProgressEntity
    columns: string[]
    isClassification: boolean
}

/** Detail view for orders without containerization: overview + rule table, no containers. */
export default function ContainerlessOrderDetail({ progress, columns, isClassification }: Props) {
    return (
        <div className="flex flex-col gap-6 mt-6">
            <OrderTemplateOverview progress={progress} isClassification={isClassification} />

            <div className="flex flex-col">
                <div className="flex rounded-t-xl">
                    <span className="px-8 py-5 text-lg font-medium text-[#1E293B] bg-white rounded-t-lg">
                        Avance
                    </span>
                </div>
                <div className="bg-white rounded-b-xl rounded-tr-xl px-6 py-6">
                    <ContainerlessRuleTable progress={progress} columns={columns} />
                </div>
            </div>
        </div>
    )
}
